import React from "react";
import { useTranslation } from "react-i18next";
import "./CarouselServicio.css";

export default function CarruselServicio() {
  const { t } = useTranslation();

  return (
    <div className="carrusel-servicio-container">
      <img
        src="/equipo3.webp"
        alt={t("carrusel_servicio.alt_image") || "Servicio"}
        className="carrusel-servicio-img"
      />
      <div className="carrusel-servicio-overlay">
        <h2 className="carrusel-servicio-title">
          {t("carrusel_servicio.title")}
          <br />
        </h2>
      </div>
    </div>
  );
}
